import React, { ReactNode } from "react"
import styles from "./Button.module.css"

interface ButtonProps {
  type: "button" | "link"
  href?: string
  target?: "_blank" | "_parent"
  children: ReactNode
  onClick?: any
}

const Button = ({ type, href, target = "_blank", children, onClick }: ButtonProps) => {
  return type === "button" ? (
    <button className={styles.button} onClick={onClick}>
      {children}
    </button>
  ) : (
    <a href={href} target={target} className={styles.button} rel="noreferrer">
      {children}
    </a>
  )
}

export default Button
